import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
import I18n from 'I18n';
export function getWebInteractivePerformanceStats(crmObject) {
  const overviewPerformanceGroup = {
    stats: [{
      formatStyle: 'decimal',
      propertyName: 'hs_views',
      value: String(getPropertyValue(crmObject, 'hs_views', ''))
    }, {
      formatStyle: 'decimal',
      propertyName: 'hs_clicks',
      value: String(getPropertyValue(crmObject, 'hs_clicks', ''))
    }, {
      formatStyle: 'percentage',
      propertyName: 'hs_click_rate',
      value: String(getPropertyValue(crmObject, 'hs_click_rate', ''))
    }],
    title: I18n.text('frameworkAssetPreviewLib.tabs.performance.performanceGroup.0-91.overview')
  };
  return Promise.resolve([overviewPerformanceGroup]);
}